import * as React from 'react';
import styled from 'styled-components';
import { InboxOutlined } from '@ant-design/icons';

import { palette } from 'theme/variables';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 56px 24px;
    background: #fff;
`;

const IconCircle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: ${palette.warm100};
    color: ${palette.forest};
    margin-bottom: 18px;

    .anticon {
        font-size: 28px;
    }
`;

const Title = styled.div`
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: ${palette.canopy};
    margin-bottom: 6px;
`;

const Subtitle = styled.div`
    font-family: 'Inter', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: ${palette.warm400};
    max-width: 360px;
    line-height: 1.5;
    margin-bottom: 18px;
`;

const Actions = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
`;

interface Props {
    title?: string;
    subtitle?: string;
    icon?: React.ReactNode;
    /* Primary CTA (typically the gold "+ Add" button). Pass a ready-made
       JSX element so the consumer keeps full control over what it does. */
    primaryAction?: React.ReactNode;
    /* Secondary muted link, eg "Browse all benefits →". */
    secondaryAction?: React.ReactNode;
}

/* Shared empty-state for list views (replaces Antd's bare default).
   Brand-tinted, on-message, offers a clear next action so users aren't
   stuck at a dead end. */
export const EmptyState: React.FC<Props> = ({
    title = 'Nothing here yet',
    subtitle = 'When records are added, they will show up in this list.',
    icon = <InboxOutlined />,
    primaryAction,
    secondaryAction,
}) => (
    <Wrapper>
        <IconCircle>{icon}</IconCircle>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
        {(primaryAction || secondaryAction) && (
            <Actions>
                {primaryAction}
                {secondaryAction}
            </Actions>
        )}
    </Wrapper>
);
